import React, { useEffect, useState } from "react";
import {
  Form,
  Image,
  Button,
  Row,
  Col,
  ButtonGroup,
  ToggleButton,
  Container,
} from "react-bootstrap";
import SellerAuth from "./SellerAuth";
import "../common/bharee-leads.css";
import bhareeLogo from "../../assets/images/bhareeLogo.png";
import bhareeBlack from "../../assets/images/BhareeBlack.png";
import isEmpty from "../../utils/is-Empty";
import { leadsFeatures } from "../../helpers";

const BhareeLeadsPage = ({
  city,
  district,
  state,
  removeHeader = false,
  removeYellowSection = false,
  sellerLogin = false,
  subscriptionData = [],
  handlePlanSelect = () => {},
  handleContinueButtonClick = () => {},
}) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [initialPlan, setInitialPlan] = useState(null);
  const thisPlanSelect = (e) => {
    const selectedValue = e.target.value;
    let plan = subscriptionData.find((sub) => sub.gateway_plan_id === selectedValue);
    plan.monthly_amount = parseInt(plan.plan_amount) / 12;
    setSelectedPlan(plan || null);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (!isEmpty(subscriptionData) && subscriptionData.length > 0) {
      let mInitial = subscriptionData[0];
      mInitial.monthly_amount = parseFloat(mInitial.plan_amount) / 12;
      setInitialPlan(mInitial);

      if (isEmpty(selectedPlan)) {
        setSelectedPlan(mInitial);
      }
    }
  }, [subscriptionData]);

  return (
    <>
      {!removeHeader && (
        <header
          className="bg-white py-3"
          style={{ borderBottom: `${sellerLogin ? "5px solid #Fbb03b" : "none"}` }}
        >
          <div className="container d-flex justify-content-center align-items-center gap-3 flex-nowrap">
            <Image
              src={bhareeLogo}
              alt="Bharee"
              className="brand-logo"
              style={{ height: "30px", objectFit: "contain" }}
            />

            <div
              className="separator"
              style={{ width: "2px", height: "40px", backgroundColor: "#FFD700" }}
            ></div>

            <div className="top-note text-center" style={{ fontSize: "1rem" }}>
              Reach buyers through Bharee directly
              <br />
              <span style={{ display: "block", textAlign: "left" }}>for orders or enquiries</span>
            </div>
          </div>
        </header>
      )}
      {/* Yellow Section */}
      {!removeYellowSection && (
        <section
          className="py-5"
          style={{ background: "linear-gradient(90deg,#fbb03b,#f7931e)", height: "222px" }}
        >
          <div className="container text-center text-white">
            <div
              className="position-relative d-inline-block rounded-pill p-5 border border-2 border-white"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                maxWidth: "1000px",
                width: "100%",
                height: "100px",
                marginTop: "30px",
              }}
            >
              <div
                className="position-absolute start-50"
                style={{ top: "-57px", transform: "translateX(-50%)" }}
              >
                <span
                  className="d-inline-block border border-2 border-white px-4 py-2 fw-bold text-white bharee-register-now"
                  style={{
                    borderRadius: "14px",
                  }}
                >
                  Register Now & Get
                </span>
              </div>

              <div
                className="position-absolute top-0 start-50 translate-middle"
                style={{ zIndex: 2 }}
              >
                <span
                  className="d-inline-block border border-3 border-white rounded-pill px-4 py-2 fw-bold text-white fs-4"
                  style={{ backgroundColor: "rgba(220, 4, 4, 0.88)" }}
                >
                  FREE Bharee Leads Plan
                </span>
              </div>

              <div
                className="position-absolute start-50"
                style={{ top: "16px", transform: "translateX(-50%)", zIndex: 0 }}
              >
                <span
                  className="d-inline-block border border-2 border-white px-4 py-1 text-white bharee-padding"
                  style={{ borderRadius: "14px" }}
                >
                  for 6 months
                </span>
              </div>

              <div
                className="position-absolute start-50 translate-middle"
                style={{ bottom: "-45px" }}
              >
                <SellerAuth
                  buttonText={"SIGN UP"}
                  registerMode={true}
                  buttonClasses={
                    "btn-danger d-inline-block border border-2 border-white rounded-pill px-4 py-2 fw-bold text-white"
                  }
                  selectedCity={city}
                  selectedDistrict={district}
                  selectedState={state}
                />
                {/* <span
                className="d-inline-block border border-2 border-white rounded-pill px-4 py-2 fw-bold text-white"
                style={{ backgroundColor: "rgba(220, 4, 4, 0.88)" }}
              >
                SIGN UP
              </span> */}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Main Content Section Mobile */}
      <main className="py-3 mobile bharee-booster-page">
        <Container fluid className="m-0 p-0">
          <Row className="m-0 p-2 border rounded-3 shadow-sm">
            <Col xs={12} className="text-center mb-4">
              {/* Wrapper to center both elements */}
              <div className="d-flex flex-column align-items-center">
                {/* Recommended pill */}
                {sellerLogin && (
                  <div
                    className="px-3 text-white"
                    style={{
                      width: "125px",
                      background: "#f1a83bff",
                      fontSize: "0.75rem",
                      zIndex: 1,
                      whiteSpace: "nowrap",
                      borderRadius: "12px",
                      borderBottomLeftRadius: "0px",
                      borderBottomRightRadius: "0px",
                      fontWeight: "600",
                      paddingTop: "4px",
                      paddingBottom: "8px",
                    }}
                  >
                    Recommended
                  </div>
                )}

                {/* Booster pill */}
                <div
                  className="d-inline-flex align-items-center px-4 py-2 border border-warning rounded-pill"
                  style={{
                    marginTop: sellerLogin ? "-5px" : "5px",
                    backgroundColor: "#ffffff",
                    zIndex: 2,
                  }}
                >
                  <Image
                    src={bhareeBlack}
                    alt="Bharee Logo"
                    className="starter-img"
                    style={{
                      height: "15px",
                      objectFit: "contain",
                      marginRight: "10px",
                      marginTop: "-3px",
                    }}
                  />
                  <span className="fw-bold text-danger starter-text">Leads</span>
                </div>

                {sellerLogin && subscriptionData.length > 0 && (
                  <div
                    class="duration-pill2 px-4 py-1 fw-bold"
                    style={{
                      border: "none",
                      background: "#fff",
                      whiteSpace: "nowrap",
                      zIndex: 1,
                    }}
                  >
                    <ButtonGroup>
                      {subscriptionData.map((radio, idx) => {
                        const isSelected = selectedPlan?.gateway_plan_id === radio.gateway_plan_id;
                        return (
                          <ToggleButton
                            key={idx}
                            id={`radio-mobile-leads-${idx}`}
                            type="radio"
                            variant={isSelected ? "primary" : "outline-primary"}
                            name="radio"
                            value={radio.gateway_plan_id}
                            checked={isSelected}
                            onChange={(e) => {
                              handlePlanSelect(e);
                              thisPlanSelect(e);
                            }}
                          >
                            {radio.plan_title}
                          </ToggleButton>
                        );
                      })}
                    </ButtonGroup>
                  </div>
                )}

                {!sellerLogin && (
                  <div className="pt-2" style={{ marginTop: "5px" }}>
                    <SellerAuth
                      buttonText={"SIGN UP"}
                      registerMode={true}
                      buttonClasses={"btn-danger rounded-pill px-4 fw-bold signup-btn"}
                      selectedCity={city}
                      selectedDistrict={district}
                      selectedState={state}
                    />
                  </div>
                )}

                <div class="price-lg mt-2">
                  <span className="price-currency" style={{ fontSize: "28px" }}>
                    <i className="bi bi-currency-rupee"></i>
                  </span>
                  <span className="price-amount" style={{ fontSize: "54px", fontWeight: "bold" }}>
                    {selectedPlan ? selectedPlan?.monthly_amount : initialPlan?.monthly_amount}
                  </span>
                </div>
                <div class="subtxt">
                  <b>/month billed annually</b>
                </div>
                <div class="subtxt">
                  <b>No monthly plan</b>
                </div>

                {sellerLogin && (
                  <div class="pt-2">
                    <Button
                      className={"btn-danger rounded-pill px-4 fw-bold signup-btn"}
                      onClick={handleContinueButtonClick}
                    >
                      Upgrade to Leads
                    </Button>
                  </div>
                )}

                <h5 className="my-2">
                  <strong>Features</strong>
                </h5>

                {leadsFeatures.map(([label, value], index) => (
                  <Row key={index} className="mb-0 w-100">
                    <Col md={6} xs={6} className="text-end small muted">
                      {label}
                    </Col>
                    <Col md={6} xs={6} className="text-start">
                      {value?.toLowerCase() === "yes" ? (
                        <i className="bi bi-check-lg text-success"></i>
                      ) : value?.toLowerCase() === "no" ? (
                        <i className="bi bi-x-lg text-danger"></i>
                      ) : (
                        <span className="small">{value}</span>
                      )}
                    </Col>
                  </Row>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </main>

      {/* Main Content Section Desktop */}
      <main className="py-5 desktop bharee-booster-page" id="pricing">
        <div class="container position-relative">
          <div
            style={{
              position: "absolute",
              top: "80px",
              bottom: "40px",
              left: "46.33%",
              width: "2px",
              background: "#ffc107",
              zIndex: 1,
            }}
          ></div>
          <div class="pricing-wrap p-3 p-md-4 p-lg-5 position-relative">
            {sellerLogin && (
              <div
                className="recommended-pill1 position-absolute px-3 text-white"
                style={{
                  top: "-45px",
                  left: "70%",
                  transform: "translateX(-50%)",
                  background: "#f1a83bff",
                  fontSize: "0.75rem",
                  zIndex: 1,
                  whiteSpace: "nowrap",
                  borderRadius: "12px",
                  borderBottomLeftRadius: "0px",
                  borderBottomRightRadius: "0px",
                  fontWeight: "600",
                  paddingTop: "4px",
                  paddingBottom: "8px",
                }}
              >
                Recommended
              </div>
            )}

            <div
              class="starter-pill d-inline-flex align-items-center px-4 py-2 border border-warning rounded-pill position-absolute"
              style={{
                top: "-21px",
                left: "70%",
                transform: "translateX(-50%)",
                background: "#fff",
                zIndex: 2,
              }}
            >
              <Image
                src={bhareeBlack}
                alt="Bharee Logo"
                className="starter-img"
                style={{
                  height: "15px",
                  objectFit: "contain",
                  marginRight: "10px",
                  marginTop: "-3px",
                }}
              />

              <span className="starter-text fw-bolder text-danger">Leads</span>
            </div>
            {sellerLogin && subscriptionData.length > 0 && (
              <div
                class="duration-pill2 position-absolute px-4 py-1 fw-bold"
                style={{
                  top: "17px",
                  left: "70%",
                  transform: "translateX(-50%)",
                  background: "#fff",
                  borderRadius: "16px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                  whiteSpace: "nowrap",
                  zIndex: 1,
                }}
              >
                <div
                  class="duration-pill2 px-4 py-1 fw-bold"
                  style={{
                    border: "none",
                    background: "#fff",
                    whiteSpace: "nowrap",
                    zIndex: 1,
                  }}
                >
                  <ButtonGroup>
                    {subscriptionData.map((radio, idx) => {
                      const isSelected = selectedPlan?.gateway_plan_id === radio.gateway_plan_id;
                      return (
                        <ToggleButton
                          key={idx}
                          id={`radio-mobile-leads-${idx}`}
                          type="radio"
                          variant={isSelected ? "primary" : "outline-primary"}
                          name="radio"
                          value={radio.gateway_plan_id}
                          checked={isSelected}
                          onChange={(e) => {
                            handlePlanSelect(e);
                            thisPlanSelect(e);
                          }}
                        >
                          {radio.plan_title}
                        </ToggleButton>
                      );
                    })}
                  </ButtonGroup>
                </div>
              </div>
            )}

            <div class="row" style={{ marginTop: sellerLogin ? "25px" : "0px" }}>
              <div class="col-5 text-end">
                <div className="fw-bold text-warning mb-4 fs-4" style={{ marginTop: "85px" }}>
                  Benefits
                </div>
              </div>

              <div class="col-7 text-center">
                <div class="price-lg">
                  <span className="price-currency" style={{ fontSize: "28px" }}>
                    <i className="bi bi-currency-rupee"></i>
                  </span>
                  <span className="price-amount" style={{ fontSize: "54px", fontWeight: "bold" }}>
                    {selectedPlan ? selectedPlan?.monthly_amount : initialPlan?.monthly_amount}
                  </span>
                </div>
                <div class="subtxt subtxt-1">
                  <b>/month billed annually</b>
                </div>
                <div class="subtxt subtxt-2">
                  <b>No monthly plan</b>
                </div>
                {!sellerLogin && (
                  <div class="pt-2">
                    <SellerAuth
                      buttonText={"SIGN UP"}
                      registerMode={true}
                      buttonClasses={"btn-danger rounded-pill px-4 fw-bold signup-btn"}
                      selectedCity={city}
                      selectedDistrict={district}
                      selectedState={state}
                    />
                  </div>
                )}
                {sellerLogin && (
                  <div className="pt-2" style={{ marginTop: "20px" }}>
                    <Button
                      className={"btn-danger rounded-pill px-4 fw-bold signup-btn"}
                      onClick={handleContinueButtonClick}
                    >
                      Upgrade to Leads
                    </Button>
                  </div>
                )}
              </div>
            </div>

            <div class="container px-0">
              <div class="feature-row row">
                <div class="col-5 text-end">Users</div>
                <div class="col-7 text-center">3</div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">Product Upload</div>
                <div class="col-7 text-center">Unlimited</div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">Offer Update</div>
                <div class="col-7 text-center">Unlimited</div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">MOQ</div>
                <div class="col-7 text-center">10 / 20 / 50+</div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">Payment</div>
                <div class="col-7 text-center">Online / PoD</div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">BIS / FSSAI Renewal Reminder</div>
                <div class="col-7 text-center">
                  <i className="bi bi-check-lg" style={{ fontSize: "1.3rem" }}></i>
                </div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">Offer Alerts</div>
                <div class="col-7 text-center">
                  <i className="bi bi-check-lg" style={{ fontSize: "1.3rem" }}></i>
                </div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">New Product Alerts</div>
                <div class="col-7 text-center">
                  <i className="bi bi-check-lg" style={{ fontSize: "1.3rem" }}></i>
                </div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">Bulk Enquiries</div>
                <div class="col-7 text-center">
                  <i className="bi bi-check-lg" style={{ fontSize: "1.3rem" }}></i>
                </div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">Cost Calculator</div>
                <div class="col-7 text-center">
                  <i className="bi bi-check-lg" style={{ fontSize: "1.3rem" }}></i>
                </div>
              </div>

              <div class="feature-row row">
                <div class="col-5 text-end">Reports</div>
                <div class="col-7 text-center">
                  <i className="bi bi-check-lg" style={{ fontSize: "1.3rem" }}></i>
                </div>
              </div>

              <div class="feature-row row last">
                <div class="col-5 text-end">
                  Support <div class="text-muted">(Mon to Sat: 10am - 6pm)</div>
                </div>
                <div class="col-7 text-center">
                  <i className="bi bi-check-lg" style={{ fontSize: "1.3rem" }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default BhareeLeadsPage;
